<template>
    <div class="blog body">
        <div id="content">
            <div class="container">
                <div class="blog-masonry" id="contentBlog">
                    <div v-for="(data, index) in json" :key="index">
                        <div v-if="index+1 <= limit">
                            <div class="post-card -center">
                                <router-link class="card__cover" :to="'/Articulo/'+data.id">
                                    <img :src="'../static/blog/img/'+data.portada" alt="Looking for some feedback for this rejected track"/>
                                    <!-- <div class="portada" :style="'height: 240px; background-image: url(./static/blog/img/'+data.imagen+');'"></div> -->
                                </router-link>
                                <div class="card__content">
                                    <h5 class="card__content-category">{{data.categoria}}</h5>
                                    <router-link class="card__content-title" :to="'/Articulo/'+data.id">{{data.titulo}}</router-link>
                                    <div class="card__content-info">
                                        <div class="info__time">
                                            <p>Publicado en {{data.fecha}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-for="(data, index) in json" :key="index">
                    <div v-if="index+1 == 1 && json.length > limit">
                        <div class="center">
                            <b-button class="btn -normal load-more-btn" @click="cargar">Ver más posts</b-button>
                        </div>
                    </div>
                </div>
                <SliderInstagram/>
            </div>
        </div>
    </div>
</template>

<script>
    import SliderInstagram from './SliderInstagram'
    import Blog from './blog.json'
    export default {
        components: {
            SliderInstagram
        },
        data(){
            return{
                json: Blog.slice().reverse(),
                limit: 0
            }
        },
        methods: {
            cargar() {
                this.limit += 9
                localStorage.setItem("limit", this.limit)
                location.reload()
            }
        },
        mounted(){
            if(localStorage.getItem("limit")){
                this.limit =  parseInt(localStorage.getItem("limit"))
            }
            else{
                this.limit = 9
            }
        }
    }
</script>

<style scoped>
    .blog{
        padding: 100px 0;
        background-color: white;
    }
    #content{
        padding: 0;
    }
    .portada{
        width: 100%; 
        background-size: cover; 
        background-position: center;
    }
    .post-card .card__cover{
        border-radius: inherit;
    }

    .card__content-title{
        font-family: 'Saira Condensed', sans-serif!important;
        font-weight: 700!important;
        text-transform: none!important;
    }

    @media screen and (max-width: 767px){
        .blog{
            padding: 80px 0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Blog.vue